import React from "react";
import "./descriptionBox.css";
const DescriptionBox = () => {
  return (
    <div className="descriptionBox">



      <div className="discriptionBox-navigator">

        <div className="discriptionBox-nan-box">Decription</div>
        <div className="discriptionBox-nan-box fade">Reviews(122)</div>
        
        </div>




        <div className="discriptionBox-Decription">
          <p>
            What is ecommerce? Ecommerce is a method of buying and selling goods
            and services online. The definition of ecommerce business can also
            include tactics like affiliate marketing. You can use ecommerce
            channels such as your own website, an established selling website
            like Amazon, or social media to drive online sales.
          </p>
          <p>
            What is ecommerce? Ecommerce is a method of buying and selling goods
            and services online. The definition of ecommerce business can also
            include tactics like affiliate marketing. You can use ecommerce
            channels such as your own website, an established selling website
            like Amazon, or social media to drive online sales.
          </p>
      </div>
      
    </div>
  );
};

export default DescriptionBox;
